
export const cookieConstants = {
    OLD_COOKIE_EXPIRATION_DATE: 'Thu, 01 Jan 1970 00:00:00 GMT',
    PRINT_OPTIONS: 'PRINT_OPTIONS'
};
